import React, { ReactElement } from 'react';
import { mainConfig } from '../../../config/config.provider';
import { DeviceDetector } from '../../../utils/helper/browserDetection';
import { Icon, SharingLayout } from './styles.Sharing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { SocialMedia } from '../../../config/models';
import { createShareInfo, ShareInfo, SocialMediaMap } from '../../../config/socialMediaMap';

const availableShares = [SocialMedia.Twitter, SocialMedia.Whatsapp, SocialMedia.Facebook, SocialMedia.Mail];

export const ShareIcon = ({ type, info }: { type: SocialMedia; info?: ShareInfo }) => (
    <a
        title={SocialMediaMap[type].alt}
        href={info ? createShareInfo(type, info) : SocialMediaMap[type].link}
        target="_blank"
    >
        <Icon content={SocialMediaMap[type].icon} hoverColor={SocialMediaMap[type].color} />
    </a>
);

export interface ShareProps {
    content?: ShareInfo;
    style?: React.CSSProperties;
    mobileUI?: ReactElement;
    iconSize?: string;
}

export const Sharing: React.FC<ShareProps> = ({ content, style, mobileUI, iconSize }) => {
    const { title, text, url } = {
        title: mainConfig.title,
        text: mainConfig.mobileShareText,
        url: mainConfig.url,
        ...content
    };
    const share = () => {
        const shareData = {
            title: title,
            text: text,
            url: url
        };
        if (DeviceDetector.isMobile && navigator.share) {
            navigator.share(shareData);
        } else if (!mainConfig.url.includes('interaktiv.br.de')) {
            alert(
                `Auf einem echten Mobilgerät würde jetzt das native Teilen-Fenster mit folgendem Inhalt aufploppen:\n\n${shareData.title}\n${shareData.text}\n${shareData.url}`
            );
        }
    };

    const getMobileShareElement = () =>
        mobileUI ? (
            React.cloneElement(mobileUI, { onClick: share })
        ) : (
            <FontAwesomeIcon icon={faShareAlt} onClick={share} />
        );

    return (
        <SharingLayout style={style} iconSize={iconSize}>
            {DeviceDetector.isPortrait
                ? getMobileShareElement()
                : availableShares.map(key => <ShareIcon key={key} type={key} info={content} />)}
        </SharingLayout>
    );
};
